export function parsePdfPath(contentUrl) {
  uploadOssToken({ file_suffix: 'pdf', only_download: 1 }).then((res) => {
    const ossData = res.data.data
    const client = new OSS({
      region: 'oss-' + ossData.region_id,
      accessKeySecret: ossData.access_secret,
      accessKeyId: ossData.access_id,
      stsToken: ossData.secret_token,
      bucket: ossData.bucket
    })
    const filename = this.$route.query.report_title + '.pdf'
    const response = {
      'content-disposition': `attachment; filename=${encodeURIComponent(filename)}`
    }
    let fileUrl = contentUrl
    fileUrl = fileUrl.substr(0, fileUrl.indexOf('.')) + '.pdf'
    const url = client.signatureUrl(fileUrl, { response })
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = url
    document.body.appendChild(iframe)
    setTimeout(() => {
      document.body.removeChild(iframe)
    }, 100)
  })
}

export function isMobile() {
  return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
}



// WEBPACK FOOTER //
// ./src/utils/util.js